// CS = Client Script
export const MANUAL_RETAKER_CS_MESSAGES = {
  READY: 'retaker_ready',
  START: 'retaker_start',
  SEND_HTML: 'retaker_send_html',
  HTML_ERROR: 'retaker_html_error',
};
